import { render, staticRenderFns } from "./taskPools.vue?vue&type=template&id=5b1f5905&scoped=true"
import script from "./taskPools.vue?vue&type=script&lang=js"
export * from "./taskPools.vue?vue&type=script&lang=js"
import style0 from "./taskPools.vue?vue&type=style&index=0&id=5b1f5905&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b1f5905",
  null
  
)

export default component.exports